import _ from 'lodash';
import React from 'react';

import {
  AddNoteButton,
  RequiresActionNoteForm,
  NotesFilters,
  ResolvableNoteBlock
} from 'components/Notes/';
import ErrorBlock from 'components/ErrorBlock';
import {default as Modal, withModal} from 'components/Modal';

import {fetchRoomsAvailability} from 'ducks/rooms';
import {
  fetchSalesNotes,
  addSalesNote,
  archiveSalesNote,
  restoreSalesNote,
  resolveSalesNote,
  editSalesNote
} from 'ducks/notes';
import {MODALS as BASE_MODALS, storeDataInModal} from 'ducks/modals';

import './styles.css';

class SalesNotesModal extends React.Component<any> {
  componentDidMount() {
    const {data: {relatedObjectId}} = this.props;

    this.props.fetchSalesNotes(
      {room: relatedObjectId, archived: false},
      this.props.storeDataExtraActions(data => ({notes: data}))
    );
  }

  openForm = () =>
    this.props.storeDataInModal({
      modalName: BASE_MODALS.SALES_NOTES,
      data: {isFormOpened: true}
    });

  closeForm = () =>
    this.props.storeDataInModal({
      modalName: BASE_MODALS.SALES_NOTES,
      data: {isFormOpened: false}
    });

  filterActiveNotes = () => {
    const {data: {relatedObjectId}} = this.props;

    this.props.fetchSalesNotes(
      {room: relatedObjectId, archived: false},
      this.props.storeDataExtraActions(data => ({notes: data}))
    );
  };

  filterArchivedNotes = () => {
    const {data: {relatedObjectId}} = this.props;

    this.props.fetchSalesNotes(
      {room: relatedObjectId, archived: true},
      this.props.storeDataExtraActions(data => ({notes: data}))
    );
  };

  archiveNote = ({noteId}) => {
    const {data: {relatedObjectId, locationRef}} = this.props;

    this.props.archiveSalesNote({note: noteId}, [
      () =>
        fetchSalesNotes(
          {room: relatedObjectId, archived: false},
          this.props.storeDataExtraActions(data => ({notes: data}))
        ),
      () => fetchRoomsAvailability({locationRef}),
      ...this.props.data.refetchExtraAction()
    ]);
  };

  restoreNote = ({noteId}) => {
    const {data: {relatedObjectId, locationRef}} = this.props;

    this.props.restoreSalesNote({note: noteId}, [
      () =>
        fetchSalesNotes(
          {room: relatedObjectId, archived: true},
          this.props.storeDataExtraActions(data => ({notes: data}))
        ),
      () => fetchRoomsAvailability({locationRef}),
      ...this.props.data.refetchExtraAction()
    ]);
  };

  resolveNote = ({noteId}) => {
    const {data: {relatedObjectId}} = this.props;

    this.props.resolveSalesNote({note: noteId}, [
      () =>
        fetchSalesNotes(
          {room: relatedObjectId, archived: false},
          this.props.storeDataExtraActions(data => ({notes: data}))
        ),
      ...this.props.data.refetchExtraAction()
    ]);
  };

  editSalesNote = ({text, noteId}) => {
    const {data: {relatedObjectId}} = this.props;

    this.props.editSalesNote({text, note: noteId}, [
      () =>
        fetchSalesNotes(
          {room: relatedObjectId, archived: false},
          this.props.storeDataExtraActions(data => ({
            notes: data,
            noteForEdit: null
          }))
        ),
      ...this.props.data.refetchExtraAction()
    ]);
  };

  selectRoomNoteForEdit = () => this.props.data.noteForEdit;

  setNoteForEdit = ({noteId}) => {
    this.props.storeDataInModal({
      modalName: BASE_MODALS.SALES_NOTES,
      data: {noteForEdit: noteId}
    });
  };

  createSalesNote = ({text, requiresAction}) => {
    const {data: {relatedObjectId, locationRef}} = this.props;

    this.props.addSalesNote({room: relatedObjectId, text, requiresAction}, [
      () =>
        fetchSalesNotes(
          {room: relatedObjectId, archived: false},
          this.props.storeDataExtraActions(data => ({notes: data}))
        ),
      () =>
        storeDataInModal({
          modalName: BASE_MODALS.SALES_NOTES,
          data: {isFormOpened: false}
        }),
      () => fetchRoomsAvailability({locationRef}),
      ...this.props.data.refetchExtraAction()
    ]);
  };

  render() {
    const {
      closeModal,
      data: {errors, notes, isFormOpened = false}
    } = this.props;

    return (
      <Modal
        show={true}
        onClose={closeModal}
        type={Modal.EXTRA_SMALL}
        className="SalesNotesModal">
        <Modal.Header heading="Sales notes" />
        <Modal.Body>
          <div className="actions">
            {!isFormOpened && (
              <div className="colab-row-space-between">
                <AddNoteButton openAddNoteForm={this.openForm} />
                <NotesFilters
                  filterActiveNotes={this.filterActiveNotes}
                  filterArchivedNotes={this.filterArchivedNotes}
                />
              </div>
            )}
            {isFormOpened && (
              <RequiresActionNoteForm
                closeForm={this.closeForm}
                submitAction={this.createSalesNote}
                formName="addSalesNote"
              />
            )}
            {_.map(errors, (error, key) => (
              <ErrorBlock key={key}>{error}</ErrorBlock>
            ))}
          </div>
          <div className="notes">
            {notes.map(note => (
              <ResolvableNoteBlock
                key={note.id}
                note={note}
                archiveNote={this.archiveNote}
                restoreNote={this.restoreNote}
                resolveNote={this.resolveNote}
                submitEditNoteForm={this.editSalesNote}
                setNoteForEdit={this.setNoteForEdit}
                addOptions={true}
                editNote={true}
                editNoteSelector={this.selectRoomNoteForEdit}
                optionsDropdownClassName="SalesNotesDropdown"
                editFormName="editSalesNote"
              />
            ))}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToModalData = (_state, data) => {
  return {
    notes: _.get(data, 'notes', []),
    noteForEdit: _.get(data, 'noteForEdit')
  };
};

const mapDispatchToProps = {
  fetchSalesNotes,
  addSalesNote,
  storeDataInModal,
  archiveSalesNote,
  restoreSalesNote,
  resolveSalesNote,
  editSalesNote
};

export default withModal(
  BASE_MODALS.SALES_NOTES,
  mapStateToModalData,
  mapDispatchToProps
)(SalesNotesModal);
